import { atom } from "jotai";

export const publicPageAtom = atom(false);
